module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "box-b"
  }, [_c('p', {
    staticClass: "fl-p0"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_c('span', {
    staticClass: "drop1"
  }, [_vm._v("S")]), _vm._v("teven McMahon, a young American struggling to reconcile his priestly vocation with his very human desire for love and intimacy, flees to Peru on mission, seeking the serenity he cannot find at home. In a tiny village in the Andes Mountains he meets a young school teacher chased by demons of her own. They soon find themselves trapped between the brutal Shining Path guerrillas who threaten mayhem across the mountain countryside and a harsh military counter-insurgency trying to quash the rebellion. Amid this historic struggle between the forces of order and ungodly acts of terror, and haunted by the legend of "), _c('em', [_vm._v("el pistaco,")]), _vm._v(" a mythical fiend believed by locals to feed on the unwary, they discover the meaning, and the price, of love.")])]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_c('p', {
    staticClass: "fl-p"
  }, [_vm._v("Author "), _c('span', {
    staticClass: "orange"
  }, [_vm._v("Lynn F. Monahan")]), _vm._v(" is an uncommonly gifted writer who leads "), _c('em', [_vm._v("Pistaco’s")]), _vm._v(" readers on an unstoppable story of love, violence, loss and redemption.")]), _vm._v(" "), _c('p', {
    staticClass: "fl-s"
  }, [_vm._v("Cover photo copyright © Robert Frerck/Robert Harding. Used with permission.")])])]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c44d19d4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/001_Flip.vue
// module id = 57
// module chunks = 0